import { ReactElement } from 'react';

import { Button } from '@equip.health/ui';

type ActionButtonProps = {
  icon?: ReactElement;
  id: string;
  isDisabled?: boolean;
  onClick?: () => void;
  title: string;
  variant?: 'solid' | 'outline' | 'ghost';
};

const ActionButton = ({
  icon,
  id,
  isDisabled,
  onClick,
  title,
  variant = 'ghost',
}: ActionButtonProps) => (
  <Button
    fontSize="12px"
    fontWeight="700"
    id={id}
    isDisabled={isDisabled}
    onClick={onClick}
    rightIcon={icon}
    size="sm"
    variant={variant}
  >
    {title}
  </Button>
);

export default ActionButton;
